import { createAsyncAction } from "../helpers";

export const getUsersAsyncAction = createAsyncAction("GET_USERS");

export const createUserAsyncAction = createAsyncAction("CREATE_USER");

export const updateUserStatusAsyncAction = createAsyncAction(
	"UPDATE_USER_STATUS"
);

export const exportUserDataAsyncAction = createAsyncAction("EXPORT_USERS");
